





































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Mixins, Watch} from "vue-property-decorator";
import SsoSatisKimlikMixin from "@/mixins/SsoSatisKimlikMixin";
import SsoCakismaDialog from "@/components/SsoCakismaDialog.vue";
import ImageShow from "@/components/ImageShow.vue";
import SeoText from "@/components/inputs/SeoText.vue";
import NewEditable from "@/components/NewEditable.vue";
import {BasketEntity} from "@/entity/BasketEntity";
import {order} from "@/entity/OrderEntity";
import axios, {AxiosResponse} from "axios";
import ProductPicker from "@/components/inputs/ProductPicker.vue";
import ProductStockPicker from "@/components/inputs/ProductStockPicker.vue";
import {ProductEntity} from "@/entity/ProductEntity";
import {city} from "@/entity/CityEntity";
import {district} from "@/entity/DistrictEntity";
import {adres} from "@/entity/AdresEntity";
import Select35 from "@/components/inputs/Select35.vue";
import {UsersEntity} from "@/entity/UsersEntity";
import Dates from "@/components/inputs/dates.vue";
import {JobType} from "@/enum/JobType";
import Email from "@/components/inputs/Email.vue";
import LetEditable from "@/components/LetEditable.vue";


class Tenant {
  first_name: string = "";
  last_name: string = "";
  email: string = "";
  office_name: string = "";
  sso_id: any = null;
  lisans_suresi: number = 0;
  product: any = null;
  product_id: number = 0;
  package: any = null;
  package_id: number = 0;
}


class NewLicence {
  first_name: string = "";
  last_name: string = "";
  user_type: string = "";
  sirket_adi: string = "";
  email: string = "";
  tc_kimlik_no: string = "";
  vergi_numarasi: string | null = "";
  password: string = "";
  // SSO eşleştirme matrisi (K1-K6) onay alanları: K2/K2B/K5 çakışması
  // operatör onayı olmadan uygulanmaz; onay bu bayrakla taşınır.
  onaylandi: boolean = false;
  secilen_user_id: number | null = null; // K5: operatörün seçtiği SSO kaydı
  onaylayan: string = "";                // panel operatörü (denetim izi için)
}

class Job {
  type_id: JobType = JobType.CreateTenant;
  status: string = "WAITING";
  args: any = {}
}

@Component({
  components: {LetEditable, Email, Dates, Select35, ProductStockPicker, ProductPicker, NewEditable, SeoText, ImageShow, SsoCakismaDialog}
})

// DEV-3174: SSO kimlik zinciri (ssoKayit, çakışma modalı, CRM geri yazma,
// checksum) OrderEdit ile ortak SsoSatisKimlikMixin'e taşındı; davranış birebir.
export default class CreateBasket extends Mixins(SsoSatisKimlikMixin) {
  alert: boolean = false;
  ekPc: any = "-";
  toplamEkPcSayisi: any = 0;
  isYear: boolean = false;
  tur: boolean = false;

  isFarkliTarih: boolean = false;

  cities: city[] = [];
  districts: district[] = [];
  musteri = false;
  isEicraPro = false;
  isEkPc = false;
  tabs = null;
  menu = false;
  different_date_sale: string = "";
  eicraproBitisTarihi: string | null = null;
  icraproWebBitisTarihi: string | null = null;

  // Yeni müşteri oluşturma değişkenleri
  yeniMusteri: boolean = false;

  // --- Satış onay ekranı durumu (SSO eşleştirme durumu SsoSatisKimlikMixin'de) ---
  onayDialog: boolean = false;           // satış öncesi onay ekranı
  onayDalKodu: string | null = null;     // ön kontrole göre beklenen dal (K1..K6)
  onayKilitNedenleri: string[] = [];     // kırmızı: onay butonunu kilitleyen sorunlar
  onayHazirlaniyor: boolean = false;     // ön kontroller sürerken
  eksikEpostaUyarisi: string[] = [];     // e-postası bulunamayan alt kullanıcı TC'leri

  // TC Kimlik düzenleme için değişkenler
  tcDuzenlemeAcik: boolean = false;

  // Çoklu kullanıcı sonuçları için değişkenler
  cokluKullaniciSonuclari: any[] = [];
  kullaniciTabloBasliklari = [
    {text: 'Müşteri No', value: 'kisi.No'},
    {text: 'Ad', value: 'kisi.Ad'},
    {text: 'Soyad', value: 'kisi.Soyadi'},
    {text: 'TC Kimlik No', value: 'kisi.TcNo'},
    {text: 'E-posta', value: 'kisi.Eposta'},
    {text: 'İşlemler', value: 'actions', sortable: false}
  ];

  // Ana kullanıcı ve alt kullanıcılar için değişkenler
  anaKullanici: any = null;
  altKullanicilar: any[] = []; // Manuel eklenenler
  mevcutAltKullanicilar: any[] = []; // DB'den gelenler
  secilenKullanicilar: any[] = []; // Sepete eklenecek kullanıcılar
  kullaniciTipi: string = 'ana'; // ana veya alt
  yeniKullaniciEklemeModunda: boolean = false; // Yeni kullanıcı ekleme modu
  yeniKullanici: any = {tc_no: '', eicra_eposta: '', selected: true}; // Yeni kullanıcı formu

  // Alt kullanıcı tablosu başlıkları
  altKullaniciTabloBasliklari = [
    {text: 'TC Kimlik No', value: 'tc_no'},
    {text: 'E-posta', value: 'eicra_eposta'},
    {text: 'İşlemler', value: 'actions', sortable: false}
  ];

  urun = {
    product: null,
    product_stock: null,
    price_type_id: null,
    product_stock_id: null,
    tc_no: null,
    eicra_eposta: null,
    piece: null,
  }

  // Tüm adresi güncelle
  async updateFullAddress() {
    try {
      let addressRes = await this.$http.post(this.$store.state.panelApiUrl + "updateFullAddress", {
        data: {
          musteri_konum_id: this.lisansKisiKurum.musteri_konum_id,
          mahalle: this.lisansKisiKurum.mahalle,
          street: this.lisansKisiKurum.street,
          binaad: this.lisansKisiKurum.binaad,
          no: this.lisansKisiKurum.no,
          daire: this.lisansKisiKurum.daire,
          yeni_adres: this.lisansKisiKurum.adres,
          kat: this.lisansKisiKurum.kat,
          postcode: this.lisansKisiKurum.postcode,
          country_id: this.lisansKisiKurum.country_id,
          district_id: this.lisansKisiKurum.district_id
        },
        sendJson: true
      });

      if (addressRes?.data?.status === 200) {
        alert(addressRes.data.message || "Adres bilgileri başarıyla kaydedildi ✅");
      } else {
        console.warn("Adres güncelleme beklenen formatta değil:", addressRes);
      }
      await this.getMusteriGuncelBilgileri();
    } catch (error) {
      console.error("Adres güncellenirken bir hata oluştu ❌", error);
      alert("Adres güncellenirken bir hata oluştu ❌");
    }
  }

  lisansKisiKurum: any = {
    id: null,
    musteri_id: null,
    musteri_no: null,
    ad: null,
    soyad: null,
    tur: null,
    email: null,
    vergi_dairesi: null,
    vergi_no: null,
    tc_no: null,
    baro_sicil_no: null,
    tbb_no: null,
    musteri_konum_id: null,
    latitude: null,
    longitude: null,
    country_id: null,
    district_id: null,
    postcode: null,
    mahalle: null,
    kat: null,
    street: null,
    binaad: null,
    no: null,
    daire: null,
    sso_user_id: null,
    adres: null,
    iletisim: [{}],
  }

  urunler: Array<{
    id: number,
    product: any,
    tc_no: any,
    eicra_eposta: any,
    product_stock: any | undefined,
    product_stock_id: any | null,
    price_type_id: 1 | 2 | undefined,
    piece: any
    price: number
  }> = [];

  userSearchMusteriNo: any = ""
  userSearchTc: any = ""
  userSearchEmail: any = ""
  kullanici: any = null;
  kisi: any = null;
  eicrapro: any = null;
  eicraproweb: any = null;


  rules: any = {
    //@ts-ignore
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return pattern.test(value) || 'Gecersiz E-Mail.'
    },
  }

  // TC Kimlik No validasyon kuralı
  tcKuralKontrol(value: string) {
    if (!value) return true;

    const tc = String(value);

    if (!/^\d{11}$/.test(tc)) {
      return "TC Kimlik No 11 rakamdan oluşmalıdır.";
    }

    const digits = tc.split('').map(Number);

    if (digits[0] === 0) {
      return "TC Kimlik No'nun ilk hanesi 0 olamaz.";
    }

    const oddSum = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const evenSum = digits[1] + digits[3] + digits[5] + digits[7];

    let tenthDigit = (oddSum * 7 - evenSum) % 10;
    if (tenthDigit < 0) {
      tenthDigit += 10;
    }

    if (digits[9] !== tenthDigit) {
      return "Geçersiz TC Kimlik No.";
    }

    const totalSum = digits.slice(0, 10).reduce((acc, digit) => acc + digit, 0);
    const eleventhDigit = totalSum % 10;

    if (digits[10] !== eleventhDigit) {
      return "Geçersiz TC Kimlik No.";
    }

    return true;
  }

  // Email validasyon kuralı
  emailKuralKontrol(value: string) {
    if (!value) return true;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!pattern.test(value)) return 'Geçerli bir e-posta adresi giriniz';
    return true;
  }

  // TC Kimlik No geçerlilik kontrolü
  tcGecerliMi(tcNo: string): boolean {
    if (!tcNo) return false;
    return this.tcKuralKontrol(tcNo) === true;
  }

  // Email geçerlilik kontrolü
  emailGecerliMi(email: string): boolean {
    if (!email) return false;
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  }

  // TC Kimlik düzenleme toggle
  tcDuzenlemeToggle() {
    this.tcDuzenlemeAcik = !this.tcDuzenlemeAcik;
  }

  // TC güncelleme sonrası
  async tcGuncellemeSonrasi(success: boolean) {
    if (success) {
      await this.getMusteriGuncelBilgileri();
      // SSO kullanıcısı için ek güncelleme
      if (this.lisansKisiKurum.sso_user_id) {
        try {
          await this.$http.post(this.$store.state.icwApiUrl + 'admin/users-tckn-update/' + this.lisansKisiKurum.sso_user_id, {
            tckn: this.lisansKisiKurum.tc_no
          });
          console.log("SSO kullanıcı TC Kimlik No güncellendi");
        } catch (e) {
          console.error("SSO kullanıcı TC Kimlik No güncellenirken hata:", e);
        }
      }
      alert('TC Kimlik numarası başarıyla güncellendi! Artık online şifre alabilirsiniz.');
      this.tcDuzenlemeAcik = false; // Alanı kapat
    }
  }


  mounted() {
    this.different_date_sale = new Date().toISOString().split('T')[0].replace(/-/g, ' ');
  }

  // Test fonksiyonları - örnekteki gibi
  kontrolEt() {
    let response = this.$http.get(this.$store.state.panelApiUrl + "getLisansAltKullanici/" + this.lisansKisiKurum.musteri_no);
    console.log("ALT KULLANICILAR", response);
  }

  testUpdateAd() {
    this.$http.post(this.$store.state.panelApiUrl + "updateAd", {
      data: {
        musteri_no: this.lisansKisiKurum.musteri_no,
        ad: "SEBO"
      },
      sendJson: true
    });
  }

  resetForm() {
    this.lisansKisiKurum = {
      id: null,
      musteri_id: null,
      musteri_no: null,
      ad: null,
      soyad: null,
      tur: false,
      email: null,
      vergi_dairesi: null,
      vergi_no: null,
      tc_no: null,
      baro_sicil_no: null,
      tbb_no: null,
      musteri_konum_id: null,
      latitude: null,
      longitude: null,
      country_id: null,
      district_id: null,
      postcode: null,
      mahalle: null,
      kat: null,
      street: null,
      binaad: null,
      no: null,
      daire: null,
      sso_user_id: null,
      adres: null,
      iletisim: [{}],
    };
  }

  iletisimBilgisiEkle() {
    this.lisansKisiKurum.iletisim.push({});
  }

  onUpdateSuccess(success: boolean) {
    if (success) {
      console.log("Güncelleme başarılı");
    }
  }

  // Her alan için ayrı success metodları
  async onUpdateAdSuccess(success: boolean) {
    if (success) {
      await this.getMusteriGuncelBilgileri();
      // SSO kullanıcısı için ek güncelleme
      if (this.lisansKisiKurum.sso_user_id) {
        try {
          await this.$http.post(this.$store.state.icwApiUrl + 'admin/users-name-update/' + this.lisansKisiKurum.sso_user_id, {
            name: this.lisansKisiKurum.ad
          });
          console.log("SSO kullanıcı adı güncellendi");
        } catch (e) {
          console.error("SSO kullanıcı adı güncellenirken hata:", e);
        }
      }
      console.log("Ad güncellendi");
    }
  }

  async onUpdateSoyadSuccess(success: boolean) {
    if (success) {
      await this.getMusteriGuncelBilgileri();
      // SSO kullanıcısı için ek güncelleme
      if (this.lisansKisiKurum.sso_user_id) {
        try {
          await this.$http.post(this.$store.state.icwApiUrl + 'admin/users-surname-update/' + this.lisansKisiKurum.sso_user_id, {
            surname: this.lisansKisiKurum.soyad
          });
          console.log("SSO kullanıcı soyadı güncellendi");
        } catch (e) {
          console.error("SSO kullanıcı soyadı güncellenirken hata:", e);
        }
      }
      console.log("Soyad güncellendi");
    }
  }

  async onUpdateEpostaSuccess(success: boolean) {
    if (success) {

      // SSO kullanıcısı için ek güncelleme
      if (this.lisansKisiKurum.sso_user_id) {
        try {
          await this.$http.post(this.$store.state.icwApiUrl + 'admin/users-email-update/' + this.lisansKisiKurum.sso_user_id, {
            email: this.lisansKisiKurum.email
          });
          console.log("SSO kullanıcı e-postası güncellendi");
        } catch (e) {
          console.error("SSO kullanıcı e-postası güncellenirken hata:", e);
        }
      }
      await this.getMusteriGuncelBilgileri();
      console.log("lisansKisiKurum ONSUCCESS",this.lisansKisiKurum);
      console.log("E-posta güncellendi");
    }
  }

  async onUpdateTcNoSuccess(success: boolean) {
    if (success) {
      await this.getMusteriGuncelBilgileri();
      // SSO kullanıcısı için ek güncelleme
      if (this.lisansKisiKurum.sso_user_id) {
        try {
          await this.$http.post(this.$store.state.icwApiUrl + 'admin/users-tckn-update/' + this.lisansKisiKurum.sso_user_id, {
            tckn: this.lisansKisiKurum.tc_no
          });
          console.log("SSO kullanıcı TC Kimlik No güncellendi");
        } catch (e) {
          console.error("SSO kullanıcı TC Kimlik No güncellenirken hata:", e);
        }
      }
      console.log("TC Kimlik No güncellendi");
    }
  }

  async onUpdateVergiNoSuccess(success: boolean) {
    if (success) {
      await this.getMusteriGuncelBilgileri();
      console.log("Vergi No güncellendi");
    }
  }

  async onUpdateVergiDairesiSuccess(success: boolean) {
    if (success) {
      await this.getMusteriGuncelBilgileri();
      console.log("Vergi Dairesi güncellendi");
    }
  }

  onUpdateBaroSicilNoSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Baro Sicil No güncellendi");
    }
  }

  onUpdateIletisimAciklamaSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("İletişim Açıklama güncellendi");
    }
  }

  onUpdateIletisimNumaraSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("İletişim Numara güncellendi");
    }
  }

  onUpdateMahalleSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Mahalle güncellendi");
    }
  }

  onUpdateStreetSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Sokak/Cadde güncellendi");
    }
  }

  onUpdateBinaadSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Bina Adı güncellendi");
    }
  }

  onUpdateNoSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Bina No güncellendi");
    }
  }

  onUpdateDaireSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Daire No güncellendi");
    }
  }

  onUpdateKatSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Kat güncellendi");
    }
  }

  onUpdatePostcodeSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Posta Kodu güncellendi");
    }
  }

  onUpdateAdresSuccess(success: boolean) {
    if (success) {
      this.getMusteriGuncelBilgileri();
      console.log("Açık Adres güncellendi");
    }
  }

  // Güncelleme sonrası tüm müşteri bilgilerini yeniden getir
  async getMusteriGuncelBilgileri() {
    try {
      if (this.lisansKisiKurum.musteri_no) {
        let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiMusteriNo/" + this.lisansKisiKurum.musteri_no);

        if (response.data && !Array.isArray(response.data)) {
          // Tek sonuç varsa
          this.kullanici = response.data;
          this.kisiKurumBilgileriAdd(this.kullanici);

          // Ana kullanıcı bilgisini de güncelle
          if (this.anaKullanici) {
            this.anaKullanici = {
              ad: this.kullanici.kisi.Ad,
              soyad: this.kullanici.kisi.Soyadi,
              email: this.kullanici.kisi.Eposta,
              tc_no: this.kullanici.kisi.TcNo,
              selected: this.anaKullanici.selected,
              eicraproBitisTarihi: this.tarihler.eicraproBitisTarihi,
              icraproWebBitisTarihi: this.tarihler.icraproWebBitisTarihi
            };
          }
        }
      }
    } catch (e) {
      console.error("Müşteri bilgileri güncellenirken hata oluştu:", e);
    }
  }

  input() {
    this.$forceUpdate();
  };


  async getKisiTc() {
    this.kullanici = null;
    this.cokluKullaniciSonuclari = [];
    try {
      if (!!this.userSearchTc) {
        let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiTc/" + this.userSearchTc);

        if (!response.data || (Array.isArray(response.data) && response.data.length === 0)) {
          // Sonuç yoksa
          alert("Bu TC kimlik numarası ile kayıtlı kullanıcı bulunamadı. Yeni müşteri oluşturabilirsiniz.");
          this.musteri = true; // Yeni müşteri kartını aç
          this.resetForm(); // Formu temizle
        } else if (Array.isArray(response.data) && response.data.length > 1) {
          // Birden fazla sonuç varsa
          this.cokluKullaniciSonuclari = response.data;
        } else {
          // Tek sonuç varsa
          this.kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
          this.musteri = true; // Kişi Kartı Açılsın

          // Ana kullanıcı bilgisini ayarla
          this.anaKullanici = {
            ad: this.kullanici.kisi.Ad,
            soyad: this.kullanici.kisi.Soyadi,
            email: this.kullanici.kisi.Eposta,
            tc_no: this.kullanici.kisi.TcNo,
            selected: true
          };
          console.log('Ana kullanıcı oluşturuldu (getKisiMusteriNo):', this.anaKullanici);

          // Ana kullanıcı oluşturduktan SONRA kişi bilgilerini ekle
          this.kisiKurumBilgileriAdd(this.kullanici);
        }
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
    }
  }

  async getKisiMusteriNo() {
    this.urunler = []; // Sepeti temizle
    this.altKullanicilar = []; // Manuel eklenen alt kullanıcıları temizle
    this.anaKullanici = null; // Ana kullanıcıyı temizle
    this.mevcutAltKullanicilar = []; // Mevcut alt kullanıcıları temizle
    this.kullanici = null;
    this.cokluKullaniciSonuclari = [];
    try {
      if (!!this.userSearchMusteriNo) {
        let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiMusteriNo/" + this.userSearchMusteriNo);

        if (!response.data || (Array.isArray(response.data) && response.data.length === 0)) {
          // Sonuç yoksa
          alert("Bu müşteri numarası ile kayıtlı kullanıcı bulunamadı. Yeni müşteri oluşturabilirsiniz.");
          this.musteri = true; // Yeni müşteri kartını aç
          this.resetForm(); // Formu temizle
        } else if (Array.isArray(response.data) && response.data.length > 1) {
          // Birden fazla sonuç varsa
          this.cokluKullaniciSonuclari = response.data;
        } else {
          // Tek sonuç varsa
          this.kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
          this.kisiKurumBilgileriAdd(this.kullanici);
          this.musteri = true; // Kişi Kartı Açılsın

          // Ana kullanıcı bilgisini ayarla
          this.anaKullanici = {
            ad: this.kullanici.kisi.Ad,
            soyad: this.kullanici.kisi.Soyadi,
            email: this.kullanici.kisi.Eposta,
            tc_no: this.kullanici.kisi.TcNo,
            eicraproBitisTarihi: this.tarihler.eicraproBitisTarihi,
            icraproWebBitisTarihi: this.tarihler.icraproWebBitisTarihi
          };
        }
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
    }
  }

  async getKisiEmail() {
    this.kullanici = null;
    this.cokluKullaniciSonuclari = [];
    try {
      if (!!this.userSearchEmail) {
        let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiEmail/" + this.userSearchEmail);

        if (!response.data || (Array.isArray(response.data) && response.data.length === 0)) {
          // Sonuç yoksa
          alert("Bu e-mail adresi ile kayıtlı kullanıcı bulunamadı. Yeni müşteri oluşturabilirsiniz.");
          this.musteri = true; // Yeni müşteri kartını aç
          this.resetForm(); // Formu temizle
        } else if (Array.isArray(response.data) && response.data.length > 1) {
          // Birden fazla sonuç varsa
          this.cokluKullaniciSonuclari = response.data;
        } else {
          // Tek sonuç varsa
          this.kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
          this.musteri = true; // Kişi Kartı Açılsın

          // Ana kullanıcı bilgisini ayarla
          this.anaKullanici = {
            ad: this.kullanici.kisi.Ad,
            soyad: this.kullanici.kisi.Soyadi,
            email: this.kullanici.kisi.Eposta,
            tc_no: this.kullanici.kisi.TcNo,
            selected: true
          };
          console.log('Ana kullanıcı oluşturuldu (getKisiMusteriNo):', this.anaKullanici);

          // Ana kullanıcı oluşturduktan SONRA kişi bilgilerini ekle
          this.kisiKurumBilgileriAdd(this.kullanici);
        }
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
    }
  }

  // Çoklu sonuçlardan kullanıcı seçme fonksiyonu
  async kullaniciSec(item: any) {
    this.urunler = []; // Sepeti temizle
    this.altKullanicilar = []; // Manuel eklenen alt kullanıcıları temizle
    this.anaKullanici = null; // Ana kullanıcıyı temizle
    this.mevcutAltKullanicilar = []; // Mevcut alt kullanıcıları temizle
    this.kullanici = item;
    this.musteri = true; // Kişi Kartı Açılsın
    this.cokluKullaniciSonuclari = []; // Sonuç listesini temizle

    // Ana kullanıcı bilgisini ayarla
    this.anaKullanici = {
      ad: this.kullanici.kisi.Ad,
      soyad: this.kullanici.kisi.Soyadi,
      email: this.kullanici.kisi.Eposta,
      tc_no: this.kullanici.kisi.TcNo,
      selected: true,
      eicraproBitisTarihi: this.tarihler ? this.tarihler.eicraproBitisTarihi : null,
      icraproWebBitisTarihi: this.tarihler ? this.tarihler.icraproWebBitisTarihi : null
    };
    console.log('Ana kullanıcı oluşturuldu (kullaniciSec):', this.anaKullanici);
    console.log('this.tarihler:', this.tarihler);

    // Ana kullanıcı oluşturduktan SONRA kişi bilgilerini ekle
    this.kisiKurumBilgileriAdd(this.kullanici);
  }

  async altKullaniciTcAra() {
    if (!this.urun.tc_no) {
      alert("Lütfen TC kimlik numarası giriniz.");
      return;
    }

    try {
      let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiTc/" + this.urun.tc_no);

      if (response.data && response.data.length > 0) {
        const kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
        if (kullanici.kisi) {
          // TC'ye göre bulunan kullanıcının e-mail bilgisini otomatik doldur
          this.urun.eicra_eposta = kullanici.kisi.Eposta;
          alert("Kullanıcı bulundu! E-mail adresi otomatik olarak dolduruldu.");
        }
      } else {
        alert("Bu TC kimlik numarası ile kayıtlı kullanıcı bulunamadı.");
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu.");
    }
  }

  async altKullaniciEmailAra() {
    if (!this.urun.eicra_eposta) {
      alert("Lütfen e-mail adresi giriniz.");
      return;
    }

    try {
      let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiEmail/" + this.urun.eicra_eposta);

      if (response.data && response.data.length > 0) {
        const kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
        if (kullanici.kisi) {
          // Email'e göre bulunan kullanıcının TC bilgisini otomatik doldur
          this.urun.tc_no = kullanici.kisi.TcNo;
          alert("Kullanıcı bulundu! TC kimlik numarası otomatik olarak dolduruldu.");
        }
      } else {
        alert("Bu e-mail adresi ile kayıtlı kullanıcı bulunamadı.");
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu.");
    }
  }

  tarihDegistir() {
    if (this.isFarkliTarih) {
      this.isFarkliTarih = true
      this.different_date_sale = ""
    } else {
      this.isFarkliTarih = false
    }
  }

  kisiKurumBilgileriAdd(kullanici: any) {

    this.resetForm();

    //Kisi - Kurum Bilgileri
    this.lisansKisiKurum.id = kullanici.kisi.KisiID;
    this.lisansKisiKurum.musteri_id = kullanici.kisi.MusteriID;
    this.lisansKisiKurum.musteri_no = kullanici.kisi.No;
    this.lisansKisiKurum.ad = kullanici.kisi.Ad;
    this.lisansKisiKurum.soyad = kullanici.kisi.Soyadi;
    this.lisansKisiKurum.tur = kullanici.kisi.Turu == "0" ? true : false; //0 : kurum - 1 : Bireysel
    this.lisansKisiKurum.email = kullanici.kisi.Eposta;
    this.lisansKisiKurum.vergi_dairesi = kullanici.kisi.VergiDairesi;
    this.lisansKisiKurum.vergi_no = kullanici.kisi.VergiNo;
    this.lisansKisiKurum.tc_no = kullanici.kisi.TcNo;
    this.lisansKisiKurum.baro_sicil_no = kullanici.kisi.BaroNo;
    this.lisansKisiKurum.tbb_no = kullanici.kisi.TBBNo;
    this.lisansKisiKurum.sso_user_id = kullanici.kisi.sso_user_id;

    // Ana kullanıcı bilgisini müşteri kartındaki bilgilerle otomatik oluştur
    this.anaKullanici = {
      ad: this.lisansKisiKurum.ad,
      soyad: this.lisansKisiKurum.soyad,
      email: this.lisansKisiKurum.email,
      tc_no: this.lisansKisiKurum.tc_no,
      selected: true,
      eicraproBitisTarihi: null,
      icraproWebBitisTarihi: null,
      BitisTarihi: '',
      Rumuz: ''
    };
    console.log('Ana kullanıcı müşteri kartından oluşturuldu:', this.anaKullanici);

    //Adres Bilgileri
    this.lisansKisiKurum.musteri_konum_id = kullanici.adres ? kullanici.adres.musteri_konum_id : null;
    this.lisansKisiKurum.musteri_id = kullanici.adres ? kullanici.adres.MusteriID : null;
    this.lisansKisiKurum.latitude = kullanici.adres ? kullanici.adres.latitude : null;
    this.lisansKisiKurum.longitude = kullanici.adres ? kullanici.adres.longitude : null;
    this.lisansKisiKurum.adres = kullanici.adres ? kullanici.adres.yeni_adres : null;
    this.lisansKisiKurum.district_id = kullanici.adres ? kullanici.adres.district_id : null;
    this.lisansKisiKurum.country_id = kullanici.adres ? kullanici.adres.country_id : null;
    this.lisansKisiKurum.postcode = kullanici.adres ? kullanici.adres.postcode : null;
    this.lisansKisiKurum.mahalle = kullanici.adres ? kullanici.adres.mahalle : null;
    this.lisansKisiKurum.kat = kullanici.adres ? kullanici.adres.kat : null;
    this.lisansKisiKurum.street = kullanici.adres ? kullanici.adres.street : null;
    this.lisansKisiKurum.binaad = kullanici.adres ? kullanici.adres.binaad : null;
    this.lisansKisiKurum.no = kullanici.adres ? kullanici.adres.no : null;
    this.lisansKisiKurum.daire = kullanici.adres ? kullanici.adres.daire : null;

    //İletişim Bilgileri
    this.lisansKisiKurum.iletisim = kullanici.iletisim;

    //Tarih Bilgileri - API yanıtındaki yapıya uygun olarak çıkarma
    if (kullanici.tarihler && kullanici.tarihler.data) {
      this.eicraproBitisTarihi = kullanici.tarihler.data.eicrapro?.eicraproBitisTarihi || null;
      this.icraproWebBitisTarihi = kullanici.tarihler.data.icraproweb?.icraproWebBitisTarihi || null;

      // Debug: Tarih verilerini console'a yazdır
      console.log('Tarih verileri:', {
        data: kullanici.tarihler.data,
        eicrapro: kullanici.tarihler.data.eicrapro,
        icraproweb: kullanici.tarihler.data.icraproweb,
        eicraproBitisTarihi: this.eicraproBitisTarihi,
        icraproWebBitisTarihi: this.icraproWebBitisTarihi
      });
    } else {
      this.eicraproBitisTarihi = null;
      this.icraproWebBitisTarihi = null;
      console.log('Kullanıcı tarih bilgileri bulunamadı', kullanici.tarihler);
    }

    // anaKullanici nesnesine de tarih verilerini set et
    if (this.anaKullanici) {
      this.anaKullanici.eicraproBitisTarihi = this.eicraproBitisTarihi;
      this.anaKullanici.icraproWebBitisTarihi = this.icraproWebBitisTarihi;
    }

    // Alt kullanıcıları getir
    console.log('kisiKurumBilgileriAdd sonunda anaKullanici:', this.anaKullanici);
    if (this.lisansKisiKurum.musteri_no) {
      this.getAltKullanicilar(this.lisansKisiKurum.musteri_no, kullanici.kisi.TcNo);
    }
    console.log('getAltKullanicilar çağrıldıktan sonra anaKullanici:', this.anaKullanici);
  }


  @Watch('lisansKisiKurum')
  onUserChange() {
    this.terminalKontrol(this.lisansKisiKurum.musteri_no)
    this.$forceUpdate();
  };

  @Watch('anaKullanici', {deep: true})
  onAnaKullaniciChange(newVal: any, oldVal: any) {
    console.log('Ana kullanıcı değişti:', {newVal, oldVal});
  }

  // Alt kullanıcıları getiren yeni fonksiyon
  async getAltKullanicilar(musteriNo: string, anaKullaniciTcNo: any) {
    // Onay ekranındaki "e-postası bulunamayan alt kullanıcı" uyarı listesi
    // her yüklemede sıfırdan kurulur.
    this.eksikEpostaUyarisi = [];
    try {
      const response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansAltKullanici/" + musteriNo);
      if (response.data && Array.isArray(response.data)) {
        // Ana kullanıcı TC'sini string'e çevir ve karşılaştırmayı güvenli hale getir
        const anaKullaniciTcStr = String(anaKullaniciTcNo);

        console.log('Ana kullanıcı TC:', anaKullaniciTcStr);
        console.log('API Response data:', response.data.map(k => ({
          SozlesmeMakSayisi: k.SozlesmeMakSayisi,
          tc: String(k.SozlesmeMakSayisi)
        })));

        const anaKullaniciVerisi = response.data.find((k: any) => String(k.SozlesmeMakSayisi) === anaKullaniciTcStr);
        const altKullaniciVerisi = response.data.filter((k: any) => String(k.SozlesmeMakSayisi) !== anaKullaniciTcStr);

        console.log('Ana kullanıcı verisi bulundu mu:', !!anaKullaniciVerisi);
        console.log('Alt kullanıcı sayısı:', altKullaniciVerisi.length);

        if (anaKullaniciVerisi && this.anaKullanici) {
          this.$set(this.anaKullanici, 'BitisTarihi', anaKullaniciVerisi.BitisTarihi || '');
          this.$set(this.anaKullanici, 'Rumuz', anaKullaniciVerisi.Rumuz || '');
          console.log('Ana kullanıcı güncellendi:', this.anaKullanici);
        } else {
          console.log('Ana kullanıcı güncellenemedi:', {
            anaKullaniciVerisi: !!anaKullaniciVerisi,
            anaKullanici: !!this.anaKullanici
          });
        }

        // Eğer ana kullanıcı yoksa ve API'den kullanıcı varsa, müşteri kartındaki bilgilerle eşleşeni bul
        if (!this.anaKullanici && response.data.length > 0) {
          console.log('Müşteri kart bilgileri:', this.lisansKisiKurum);

          // Müşteri kartındaki TC ile eşleşen kullanıcıyı bul
          const anaKullaniciVerisi = response.data.find((k: any) =>
              String(k.SozlesmeMakSayisi) === String(this.lisansKisiKurum.tc_no)
          );

          const ilkKullanici = anaKullaniciVerisi || response.data[0];
          this.anaKullanici = {
            ad: ilkKullanici.Ad || '',
            soyad: ilkKullanici.Soyad || '',
            email: '', // Email ayrıca getirilecek
            tc_no: ilkKullanici.SozlesmeMakSayisi,
            selected: true,
            BitisTarihi: ilkKullanici.BitisTarihi || '',
            Rumuz: ilkKullanici.Rumuz || ''
          };

          // İlk kullanıcının emailini getir
          try {
            const emailResp = await this.$http.get(this.$store.state.icwApiUrl + "admin/user-tckn-check/" + ilkKullanici.SozlesmeMakSayisi);
            // exists:false iken user null gelir; `?.` user'a uygulanmadığı için
            // TypeError -> catch -> SESSİZCE boş e-posta oluşuyordu.
            this.anaKullanici.email = emailResp.data?.exists ? (emailResp.data?.user?.email || "") : "";
          } catch (e) {
            this.anaKullanici.email = "";
          }
          if (!this.anaKullanici.email && ilkKullanici.SozlesmeMakSayisi) {
            this.eksikEpostaUyarisi.push(String(ilkKullanici.SozlesmeMakSayisi));
          }

          console.log('İlk kullanıcı ana kullanıcı olarak ayarlandı:', this.anaKullanici);

          // Ana kullanıcıyı alt kullanıcılar listesinden çıkar
          const altKullaniciVerisi = response.data.slice(1); // İlk kullanıcı hariç kalanlar

          this.mevcutAltKullanicilar = await Promise.all(altKullaniciVerisi.map(async (kullanici: any) => {
            const tc_no = kullanici.SozlesmeMakSayisi || "";
            let email = "";
            if (tc_no) {
              try {
                const emailResp = await this.$http.get(this.$store.state.icwApiUrl + "admin/user-tckn-check/" + tc_no);
                // exists:false iken user null gelir; `?.` user'a uygulanmadığı
                // için TypeError -> catch -> SESSİZCE boş e-posta oluşuyordu.
                email = emailResp.data?.exists ? (emailResp.data?.user?.email || "") : "";
              } catch (e) {
                email = "";
              }
              if (!email) {
                this.eksikEpostaUyarisi.push(String(tc_no));
              }
            }
            console.log('Alt kullanıcı email:', {tc_no, email});
            return {
              ...kullanici,
              selected: false,
              tc_no,
              bitis_tarihi: kullanici.BitisTarihi || "",
              eicra_eposta: email,
            };
          }));
        } else {
          // Normal akış: Ana kullanıcı varsa, onu hariç tut
          this.mevcutAltKullanicilar = await Promise.all(altKullaniciVerisi.map(async (kullanici: any) => {
            const tc_no = kullanici.SozlesmeMakSayisi || "";
            let email = "";
            if (tc_no) {
              try {
                const emailResp = await this.$http.get(this.$store.state.icwApiUrl + "admin/user-tckn-check/" + tc_no);
                // exists:false iken user null gelir; `?.` user'a uygulanmadığı
                // için TypeError -> catch -> SESSİZCE boş e-posta oluşuyordu.
                email = emailResp.data?.exists ? (emailResp.data?.user?.email || "") : "";
              } catch (e) {
                email = "";
              }
              if (!email) {
                this.eksikEpostaUyarisi.push(String(tc_no));
              }
            }
            console.log('Alt kullanıcı email:', {tc_no, email});
            return {
              ...kullanici,
              selected: false,
              tc_no,
              bitis_tarihi: kullanici.BitisTarihi || "",
              eicra_eposta: email,
            };
          }));
        }
      } else {
        this.mevcutAltKullanicilar = [];
      }
    } catch (e) {
      console.error('getAltKullanicilar error:', e);
      this.mevcutAltKullanicilar = [];
    }
  }


  urunChange(item: any) {
    if (item.product_id == 8) {
      this.isEicraPro = true;

      // Yeni müşteri için E-icraPro seçildiğinde ana kullanıcı oluştur
      if (this.yeniMusteri && this.lisansKisiKurum.ad && this.lisansKisiKurum.soyad) {
        this.anaKullanici = {
          ad: this.lisansKisiKurum.ad,
          soyad: this.lisansKisiKurum.soyad,
          email: this.lisansKisiKurum.email || '',
          tc_no: this.lisansKisiKurum.tc_no || '',
          selected: true,
          BitisTarihi: '',
          Rumuz: this.lisansKisiKurum.Rumuz || '',
        };
      }
    } else {
      this.isEicraPro = false;
    }
  };

  urunTuruChange(item: any) {
    if (item.product_stock_id == 24) {
      this.isEkPc = true;
    } else {
      this.isEkPc = false;
    }
  };

  terminalKontrol(musteriNo: any) {
    this.$http.get(this.$store.state.panelApiUrl + "ekPcKontrol/" + musteriNo).then((response: AxiosResponse) => {
          this.ekPc = response.data.data
          this.toplamEkPcSayisi = this.ekPc ? this.ekPc : 0;
        }
    );
  }

  deleteBasketItem(index: number) {
    this.urunler.splice(index, 1);
  }

  async duzenleKullaniciBilgisi(item: any, alan: string) {
    try {
      let yeniDeger = "";

      if (item) {
        if (alan === 'tc_no') {
          yeniDeger = item.tc_no;
        } else if (alan === 'email') {
          yeniDeger = item.eicra_eposta;
        }

        if (yeniDeger) {
          // Önce yerel olarak alt kullanıcı bilgilerini güncelle
          if (alan === 'tc_no' || alan === 'email') {
            const altKullaniciIndex = this.altKullanicilar.findIndex(k =>
                (alan === 'tc_no' && k.tc_no === item.tc_no) ||
                (alan === 'email' && k.eicra_eposta === item.eicra_eposta)
            );

            if (altKullaniciIndex !== -1) {
              if (alan === 'tc_no') {
                this.altKullanicilar[altKullaniciIndex].tc_no = yeniDeger;
              } else if (alan === 'email') {
                this.altKullanicilar[altKullaniciIndex].eicra_eposta = yeniDeger;
              }
            }
          }

          // Kullanıcı bilgilerini güncelleyen endpoint çağrısı
          // Not: Bu endpoint henüz backend'de hazır olmayabilir
          try {
            const endpoint = alan === 'tc_no' ? "guncelleKullaniciTcNo" : "guncelleKullaniciEmail";
            const response = await this.$http.post(this.$store.state.panelApiUrl + endpoint, {
              sepetItemId: item.id,
              yeniDeger: yeniDeger
            });

            if (response.data && response.data.success) {
              alert("Kullanıcı bilgileri başarıyla güncellendi!");
            } else {
              alert("Güncelleme işlemi başarısız oldu. Lütfen daha sonra tekrar deneyin.");
            }
          } catch (error) {
            console.error("API hatası:", error);
            alert("Güncelleme işlemi sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyin.");
          }
        }
      }
    } catch (error) {
      console.error("Genel hata:", error);
      alert("İşlem sırasında beklenmeyen bir hata oluştu.");
    }
  }

  onPieceChange(item: any) {
    item.price = Number(item.product_stock ? (item.price_type_id == 1 ? item.product_stock.price : item.product_stock.price_year) : item.product.price) * item.piece;
  }

  onIsYearChange(event: any) {
    //@ts-ignore
    event ? this.urun.price_type_id = 2 : this.urun.price_type_id = 1;
  }


  @Watch('urun.product.product_id')
  onProductIdChange1() {
    this.isYear = false;
    if (this.urun.product) {
      //@ts-ignore
      if (this.urun.product.product_id == 1) {
        this.isYear = true;
      }
    }
  }

  @Watch('kullaniciTipi')
  onKullaniciTipiChange() {
    // Kullanıcı tipini değiştirdiğinde alt kullanıcı alanlarını temizle
    if (this.kullaniciTipi === 'ana') {
      this.urun.tc_no = null;
      this.urun.eicra_eposta = null;
    }
  }

  // Yeni müşteri bilgileri değiştiğinde ana kullanıcıyı güncelle
  @Watch('lisansKisiKurum.ad')
  @Watch('lisansKisiKurum.soyad')
  @Watch('lisansKisiKurum.eicrapro_eposta')
  @Watch('lisansKisiKurum.tc_no')
  onYeniMusteriBilgileriChange() {
    if (this.yeniMusteri && this.isEicraPro) {
      // Eğer ana kullanıcı yoksa ve gerekli bilgiler varsa oluştur
      if (!this.anaKullanici && this.lisansKisiKurum.ad && this.lisansKisiKurum.soyad) {
        this.anaKullanici = {
          ad: this.lisansKisiKurum.ad,
          soyad: this.lisansKisiKurum.soyad,
          email: this.lisansKisiKurum.eicra_eposta || '',
          tc_no: this.lisansKisiKurum.tc_no || '',
          selected: true,
          BitisTarihi: '',
          Rumuz: ''
        };
      }
      // Eğer ana kullanıcı varsa güncelle
      else if (this.anaKullanici) {
        this.anaKullanici.ad = this.lisansKisiKurum.ad || '';
        this.anaKullanici.soyad = this.lisansKisiKurum.soyad || '';
        this.anaKullanici.email = this.lisansKisiKurum.email || '';
        this.anaKullanici.tc_no = this.lisansKisiKurum.tc_no || '';
      }
    }
  }


  addUrun() {
    if (this.isEicraPro) {
      // E-icraPro için seçilen kullanıcıları kontrol et
      if (this.secilenKullaniciSayisi === 0) {
        alert('E-icraPro ürünü için en az bir kullanıcı seçmelisiniz!');
        return;
      }

      // Seçilen her kullanıcı için ayrı sepet öğesi oluştur
      this.secilenKullanicilariSepeteEkle();
    } else {
      // Normal ürünler için eski mantık
      this.normalUrunSepeteEkle();
    }
  }

  secilenKullanicilariSepeteEkle() {
    //@ts-ignore
    let baseId = this.urunler.length == 0 ? 1 : (this.urunler.slice(-1).id + 1);

    // Ana kullanıcı seçildiyse ekle
    if (this.anaKullanici && this.anaKullanici.selected) {
      // Rumuz fallback: Rumuz yoksa ad+soyad, o da yoksa "Ana Kullanıcı"
      const anaRumuz = this.anaKullanici.Rumuz ||
          (this.anaKullanici.ad && this.anaKullanici.soyad ?
              this.anaKullanici.ad + ' ' + this.anaKullanici.soyad : 'Ana Kullanıcı');
      this.kullaniciSepeteEkle(baseId++, this.anaKullanici.tc_no, this.anaKullanici.email, anaRumuz);
    }

    // Mevcut alt kullanıcıları ekle - eicra_eposta kullan
    this.mevcutAltKullanicilar.forEach((kullanici, index) => {
      if (kullanici.selected) {
        // user-tckn-check'ten gelen email'i eicra_eposta olarak kullan
        const eposta = kullanici.eicra_eposta || kullanici.email || '';
        // Rumuz fallback: Rumuz yoksa TC numarası kullan
        const altRumuz = kullanici.Rumuz || kullanici.tc_no || 'Alt Kullanıcı';
        this.kullaniciSepeteEkle(baseId++, kullanici.tc_no, eposta, altRumuz);
      }
    });

    // Manuel eklenen alt kullanıcıları ekle
    this.altKullanicilar.forEach((kullanici, index) => {
      if (kullanici.selected) {
        // Manuel eklenen kullanıcılar için de eicra_eposta kullan
        const eposta = kullanici.eicra_eposta || kullanici.email || '';
        // Rumuz fallback: Rumuz yoksa TC numarası kullan
        const manuelRumuz = kullanici.Rumuz || kullanici.tc_no || 'Yeni Kullanıcı';
        this.kullaniciSepeteEkle(baseId++, kullanici.tc_no, eposta, manuelRumuz);
      }
    });

    // Başarılı mesaj
    alert(`${this.secilenKullaniciSayisi} kullanıcı için E-icraPro ürünü sepete eklendi!`);
    this.ekPcMakineleriniEkle();
  }

  kullaniciSepeteEkle(id: number, tcNo: string, eposta: string, rumuz?: string) {
    // Kullanıcının sepette olup olmadığını kontrol et
    if (tcNo && this.urunler.some(item => item.tc_no === tcNo)) {
      if (this.$toast) {
        this.$toast.warning(`Bu kullanıcı zaten sepete eklenmiş.`);
      }
      return; // Eğer kullanıcı zaten sepetteyse, ekleme yapma
    }
    if (this.urun.product_stock) {
      this.urunler.push({
        id: id,
        product: this.urun.product,
        product_stock: this.urun.product_stock,
        //@ts-ignore
        product_stock_id: this.urun.product_stock.product_stock_id,
        //@ts-ignore
        price_type_id: this.urun.price_type_id,
        piece: this.urun.piece ? this.urun.piece : 1,
        tc_no: tcNo,
        eicra_eposta: eposta,
        Rumuz: rumuz || '',
        kullanici_tipi: this.getKullaniciTipiByTcNo(tcNo),
        //@ts-ignore
        price: Number(this.urun.price_type_id == 1 ? this.urun.product_stock.price : this.urun.product_stock.price_year)
      });

      //@ts-ignore
      if (this.urun.product_stock.product_stock_id == 24 && this.toplamEkPcSayisi > 0) { //YILLIK GUNCELLEME ANLAŞMASI
        this.urunler.push({
          id: id + 1,
          piece: this.toplamEkPcSayisi,
          price: 525,
          price_type_id: 2,
          product: {
            cat_id: null,
            enabled: "1",
            name: "İcraPro",
            no: "2",
            price: "8300.00",
            product_id: "1",
            product_stock: [],
            stock_code: null,
          },
          product_stock: {
            ex_price: null,
            ex_price_year: null,
            is_amount: null,
            is_aylik: null,
            level: "1",
            name: "Feragat Makine Güncelleme",
            package_title: null,
            price: null,
            price_year: "525",
            product_option_id: "10",
            product_sku_id: "1",
            product_stock_id: "1898",
            sozlesme_id: "1",
            special_price: null,
            stock: "9999999",
            subtitle: null,
            total_stock: "9999999",
          },
          product_stock_id: 1898,
          tc_no: null,
          eicra_eposta: eposta,
        });
        this.isEkPc = false;
      }
    } else {
      this.urunler.push({
        id: id,
        product: this.urun.product,
        product_stock: null,
        product_stock_id: null,
        tc_no: tcNo,
        eicra_eposta: eposta,
        //@ts-ignore
        price_type_id: null,
        piece: this.urun.piece ? this.urun.piece : 1,
        //@ts-ignore
        price: Number(this.urun.product.price)
      });
    }
  }

  normalUrunSepeteEkle() {
    //@ts-ignore
    let id = this.urunler.length == 0 ? 1 : (this.urunler[this.urunler.length - 1].id + 1);

    if (this.urun.product_stock) {
      this.urunler.push({
        id: id,
        product: this.urun.product,
        product_stock: this.urun.product_stock,
        //@ts-ignore
        product_stock_id: this.urun.product_stock.product_stock_id,
        //@ts-ignore
        price_type_id: this.urun.price_type_id,
        piece: this.urun.piece ? this.urun.piece : 1,
        tc_no: null,
        eicra_eposta: null,
        //@ts-ignore
        price: Number(this.urun.price_type_id == 1 ? this.urun.product_stock.price : this.urun.product_stock.price_year)
      });
      this.ekPcMakineleriniEkle();
    } else {
      this.urunler.push({
        id: id,
        product: this.urun.product,
        product_stock: null,
        product_stock_id: null,
        tc_no: null,
        eicra_eposta: null,
        Rumuz: '',
        kullanici_tipi: 'normal',
        //@ts-ignore
        price_type_id: null,
        piece: this.urun.piece ? this.urun.piece : 1,
        //@ts-ignore
        price: Number(this.urun.product.price)
      });
    }
    // Form alanlarını temizle
    //@ts-ignore
    this.urun = {
      product: null,
      product_stock: null,
      price_type_id: null,
      tc_no: null,
      eicra_eposta: null,
      piece: null
    }

    // Alt kullanıcı seçiliyse TC ve email alanlarını temizle
    if (this.kullaniciTipi === 'alt') {
      this.urun.tc_no = null;
      this.urun.eicra_eposta = null;
    }

    console.log("2222", this.urunler);
  }

  ekPcMakineleriniEkle() {
    //@ts-ignore
    if (this.urun.product_stock && this.urun.product_stock.product_stock_id == 24 && this.toplamEkPcSayisi > 0) { //YILLIK GUNCELLEME ANLAŞMASI
      this.urunler.push({
        id: this.urunler.length == 0 ? 1 : (this.urunler[this.urunler.length - 1].id + 1),
        piece: this.toplamEkPcSayisi,
        price: 525,
        price_type_id: 2,
        product: {
          cat_id: null,
          enabled: "1",
          name: "İcraPro",
          no: "2",
          price: "8300.00",
          product_id: "1",
          product_stock: [],
          stock_code: null,
        },
        product_stock: {
          ex_price: null,
          ex_price_year: null,
          is_amount: null,
          is_aylik: null,
          level: "1",
          name: "Feragat Makine Güncelleme",
          package_title: null,
          price: null,
          price_year: "525",
          product_option_id: "10",
          product_sku_id: "1",
          product_stock_id: "1898",
          sozlesme_id: "1",
          special_price: null,
          stock: "9999999",
          subtitle: null,
          total_stock: "9999999",
        },
        product_stock_id: 1898,
        tc_no: null,
        eicra_eposta: null,
      });
      this.isEkPc = false;
    }
  }

  get toplamFiyat() {
    let toplam = 0;
    for (const urun of this.urunler) {
      toplam += urun.price * urun.piece;
    }
    return toplam;
  }

  getFromCities(country_id: number) {
    if (!country_id) {
      return [];
    }
    return this.cities.filter(x => x.country_id == country_id)
  }

  getFromDistricts(city_id: number) {
    return this.districts.filter(x => x.city_id == city_id)
  }

  isKurum(deger: any) {
    //true geliyorsa  ....kurumdur |  - false geliyorsa ...kişidir
    this.lisansKisiKurum.tur = deger;
  }

  async created() {
    this.cities = await this.$store.dispatch("getCities");
    this.districts = await this.$store.dispatch("getDistricts");
  }


  // tcknGecerliMi / vknGecerliMi / dalAciklamasi -> SsoSatisKimlikMixin'de.

  get onayKilitli(): boolean {
    return this.onayKilitNedenleri.length > 0 || this.onayHazirlaniyor;
  }

  /**
   * Satış öncesi ön kontrol: checksum/e-posta kilitleri + beklenen SSO dalı.
   * Buradaki dal GÖSTERMELİKTİR (operatör ne olacağını önceden görsün diye);
   * bağlayıcı karar ve onay zorunluluğu SSO'daki matristedir (409).
   */
  async onayEkraniniHazirla() {
    this.onayHazirlaniyor = true;
    this.onayDalKodu = null;
    this.onayKilitNedenleri = [];
    this.cakismaOnaylandi = false;
    this.secilenAdayId = null;

    const kurumMu = !!this.lisansKisiKurum.tur;
    const email = (this.lisansKisiKurum.email || "").toString().trim().toLowerCase();
    const kimlik = kurumMu
        ? (this.lisansKisiKurum.vergi_no || "").toString().trim()
        : (this.lisansKisiKurum.tc_no || "").toString().trim();

    if (!((this.lisansKisiKurum.ad || "").toString().trim())) {
      this.onayKilitNedenleri.push(kurumMu ? "Şirket adı boş olamaz." : "Ad boş olamaz.");
    }
    if (!email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      this.onayKilitNedenleri.push("E-posta boş ya da geçersiz.");
    }
    if (kimlik) {
      const gecerli = kurumMu ? this.vknGecerliMi(kimlik) : this.tcknGecerliMi(kimlik);
      if (!gecerli) {
        this.onayKilitNedenleri.push(kurumMu
            ? "Vergi kimlik numarası doğrulamadan (checksum) geçmiyor."
            : "TC kimlik numarası doğrulamadan (checksum) geçmiyor.");
      }
    }

    try {
      const istekler: any[] = [
        this.$http.post(this.$store.state.icwApiUrl + "admin/user-email-check", {email: email}),
      ];
      if (kimlik) {
        istekler.push(this.$http.get(this.$store.state.icwApiUrl
            + (kurumMu ? "admin/user-vkn-check/" : "admin/user-tckn-check/") + kimlik));
      }
      const yanitlar = await Promise.all(istekler);

      // İki ucun yanıt zarfı farklı: email-check {data:{exists,user}},
      // tckn/vkn-check {exists,user}. İkisine de dayanıklı çözümle.
      const emailVeri = yanitlar[0]?.data?.data || yanitlar[0]?.data || {};
      const epostaKaydi = emailVeri.exists ? emailVeri.user : null;
      const kimlikVeri = yanitlar[1] ? (yanitlar[1].data?.data || yanitlar[1].data || {}) : {};
      const kimlikKaydi = kimlikVeri.exists ? kimlikVeri.user : null;

      if (kimlikKaydi && epostaKaydi) {
        this.onayDalKodu = String(kimlikKaydi.id) === String(epostaKaydi.id) ? "K1" : "K5";
      } else if (kimlikKaydi) {
        this.onayDalKodu = "K2";
      } else if (epostaKaydi) {
        const kayitKimlik = String((kurumMu ? epostaKaydi.vergi_numarasi : epostaKaydi.tc_kimlik_no) || "").trim();
        if (!kimlik) this.onayDalKodu = "K4";
        else if (!kayitKimlik) this.onayDalKodu = "K3";
        else this.onayDalKodu = kayitKimlik === kimlik ? "K1" : "K2B";
      } else {
        this.onayDalKodu = "K6";
        if (!kimlik) {
          this.onayKilitNedenleri.push(kurumMu
              ? "Yeni SSO kaydı için vergi kimlik numarası zorunlu."
              : "Yeni SSO kaydı için TC kimlik numarası zorunlu.");
        }
      }
    } catch (e) {
      // Ön kontrol göstermeliktir; ulaşılamazsa satış kilitlenmez, dal
      // bilinmiyor olarak gösterilir. Asıl karar kayıtta (409) verilir.
      console.error("SSO ön kontrol hatası:", e);
      this.onayDalKodu = null;
    } finally {
      this.onayHazirlaniyor = false;
    }
  }

  /**
   * "Sepet Oluştur" girişi: DOĞRUDAN satış yapmaz; ön kontrolleri çalıştırıp
   * onay ekranını açar. Satış, ekrandaki "Bilgileri Onayla" ile başlar.
   */
  async save() {
    // Çift tık / yeniden giriş koruması.
    if (this.saving || this.onayHazirlaniyor) {
      return;
    }

    if (this.urunler.length < 1 || (this.lisansKisiKurum.email == null && this.lisansKisiKurum.tc_no == null)) {
      this.alert = true;
      return;
    }

    this.onayDialog = true;
    await this.onayEkraniniHazirla();
  }

  /** Onay ekranındaki "Bilgileri Onayla ve Sepet Oluştur" butonu. */
  async onaylaVeOlustur() {
    if (this.saving || this.onayKilitli) {
      return;
    }
    this.onayDialog = false;
    this.saving = true;
    try {
      await this.sepetiOlustur();
    } finally {
      this.saving = false;
    }
  }

  // ssoKayit / crmSsoGeriYaz / cakismaModaliniAc / cakismaVazgec / cakismaOnayla
  // -> SsoSatisKimlikMixin'de (DEV-3174: OrderEdit ile ortak).

  /** Mixin hook'u: operatör çakışmayı onayladığında satış zinciri buradan sürer. */
  cakismaSonrasiDevam() {
    return this.sepetiOlustur();
  }

  async sepetiOlustur() {
    let baskets: any[] = [];
    this.urunler.forEach((urun: any) => {
      baskets.push({
        'product_id': urun.product.product_id,
        'product_stock_id': urun.product_stock_id,
        'price_type_id': urun.price_type_id,
        'piece': urun.piece,
        'tc_kimlik_no': urun.tc_no,
        'eicra_eposta': urun.eicra_eposta,
        'rumuz': urun.Rumuz,
        'eicraproBitisTarihi': urun.eicraproBitisTarihi,
        'icraproWebBitisTarihi': urun.icraproWebBitisTarihi,
      })
    });

    let licence = new NewLicence();
    let requestPayload: any = {};

    // SSO kaydı HER İKİ dalda ve HER ZAMAN yapılır. Mevcut müşteride
    // sso_user_id dolu olsa bile çağrılır: CRM'deki id ÖLÜ olabilir
    // (ölçüm: 37.896 kaydın %88,7'si SSO'da yok). Uç idempotent — kayıt
    // güncelse aynı id döner (K1), değilse matris gereğini yapar.
    licence.user_type = this.lisansKisiKurum.tur ? "company" : "person"
    licence.first_name = this.lisansKisiKurum.ad ? this.lisansKisiKurum.ad : ""
    licence.last_name = this.lisansKisiKurum.soyad ? this.lisansKisiKurum.soyad : ""
    licence.sirket_adi = this.lisansKisiKurum.tur ? this.lisansKisiKurum.ad + " " + this.lisansKisiKurum.soyad : ""
    licence.email = this.lisansKisiKurum.email
    licence.tc_kimlik_no = this.lisansKisiKurum.tc_no ? this.lisansKisiKurum.tc_no.toString() : ""
    licence.vergi_numarasi = this.lisansKisiKurum.vergi_no ? this.lisansKisiKurum.vergi_no.toString() : null
    licence.password = "yeni"

    const ssoUserId = await this.ssoKayit(licence);
    if (!ssoUserId) {
      // Çakışma modalı açıldı ya da hata gösterildi; satış DURUR.
      return;
    }
    this.lisansKisiKurum.sso_user_id = ssoUserId;

    // CRM geri yazma (ölü bağ onarımı): yeni satış CRM'den GEÇMİYOR —
    // createOrder mağazaya gider ve mağaza CRM'e yazmaz. kisi.sso_user_id
    // burada tazelenmezse bayat kalır ve mağazanın "Hesabım" ürün listesi
    // (getUrunlerim bu kolonla çözüyor) müşteriye boş döner.
    // Mevcut müşteride KisiID de gönderilir: kimlik alanları satışta değişmiş
    // olabileceği (K2/K2B) için en güvenilir eşleşme odur.
    await this.crmSsoGeriYaz(ssoUserId, {
      KisiID: (!this.yeniMusteri && this.lisansKisiKurum.id) ? this.lisansKisiKurum.id : null,
      email: this.lisansKisiKurum.email,
      tckimlikno: this.lisansKisiKurum.tc_no,
      tax_number: this.lisansKisiKurum.vergi_no,
    });

    // Yeni müşteri oluşturma veya mevcut müşteri güncelleme
    if (this.yeniMusteri) {
      // Yeni müşteri için request payload
      requestPayload = {
        "user": {
          "Ad": this.lisansKisiKurum.ad,
          "Soyadi": this.lisansKisiKurum.soyad,
          "Turu": this.lisansKisiKurum.tur ? "kurum" : "kisi",
          "Eposta": this.lisansKisiKurum.email,
          "WebSitesi": null,
          "fotograf": null,
          "TcNo": this.lisansKisiKurum.tc_no,
          "VergiNo": this.lisansKisiKurum.vergi_no,
          "BaroNo": this.lisansKisiKurum.baro_sicil_no,
          "VergiDairesi": this.lisansKisiKurum.vergi_dairesi,
          "No": this.lisansKisiKurum.musteri_no,
          "sso_user_id": this.lisansKisiKurum.sso_user_id ? this.lisansKisiKurum.sso_user_id.toString() : null,
          "eicraproBitisTarihi": this.eicraproBitisTarihi,
          "icraproWebBitisTarihi": this.icraproWebBitisTarihi
        },
        "adres": {
          "DifferentAdres": null,
          "Adres": this.lisansKisiKurum.adres || this.buildFullAddress(),
          "Turu": null,
          "KurumAdi": null,
          "IlID": this.lisansKisiKurum.country_id,
          "IlceID": this.lisansKisiKurum.district_id,
          "FaturaAdres": null,
          "FaturaIlceID": null,
          "FaturaIlID": null,
        },
        "telefon": [],
        "different_date_sale": new Date(this.different_date_sale).toLocaleDateString(),
        "baskets": baskets,
        "yeni_musteri": true
      };
    } else {
      // Mevcut müşteri: SSO kaydı yukarıda (ssoKayit) HER ZAMAN yapıldı.
      // Eski koddaki `if (!sso_user_id)` varlık kontrolü ve hatayı yutan
      // catch bilinçli olarak kaldırıldı (ölü bağ + sessiz hata kusurları).

      // Mevcut müşteri için request payload
      requestPayload = {
        "user": {
          "id": this.lisansKisiKurum.id,
          "Ad": this.lisansKisiKurum.ad,
          "Soyadi": this.lisansKisiKurum.soyad,
          "Turu": this.lisansKisiKurum.tur ? "kurum" : "kisi",
          "Eposta": this.lisansKisiKurum.email,
          "WebSitesi": null,
          "fotograf": null,
          "TcNo": this.lisansKisiKurum.tc_no,
          "VergiNo": this.lisansKisiKurum.vergi_no,
          "BaroNo": this.lisansKisiKurum.baro_sicil_no,
          "VergiDairesi": this.lisansKisiKurum.vergi_dairesi,
          "sso_user_id": this.lisansKisiKurum.sso_user_id ? this.lisansKisiKurum.sso_user_id.toString() : null,
          'musteri_no': this.lisansKisiKurum.musteri_no,
          "eicraproBitisTarihi": this.eicraproBitisTarihi,
          "icraproWebBitisTarihi": this.icraproWebBitisTarihi
        },
        "adres": {
          "DifferentAdres": null,
          "AdresId": this.lisansKisiKurum.adres_id,
          "Adres": this.lisansKisiKurum.adres || this.buildFullAddress(),
          "Turu": null,
          "KurumAdi": null,
          "IlID": this.lisansKisiKurum.country_id,
          "IlceID": this.lisansKisiKurum.district_id,
          "FaturaAdres": null,
          "FaturaIlceID": null,
          "FaturaIlID": null,
        },
        "telefon": [],
        "different_date_sale": new Date(this.different_date_sale).toLocaleDateString(),
        "baskets": baskets,
        "yeni_musteri": false,
      };
    }

    // İletişim bilgilerini ekle
    if (this.lisansKisiKurum.iletisim) {
      this.lisansKisiKurum.iletisim.forEach((iletisim: any) => {
        if (iletisim.Turu && iletisim.Numara) {
          requestPayload.telefon.push(
              {
                'Numara': iletisim.Numara,
                'TelefonTuru': iletisim.Turu
              }
          )
        }
      });
    }

    try {
      let added = await this.$http.post("/createOrder/", {data: JSON.stringify(requestPayload)});
      this.$store.dispatch("go", "/siparis/detay/" + added.data.order_id);
    } catch (e) {
      alert(e.message);
    }
  }

  // Adres bilgilerinden tam adres oluştur
  buildFullAddress(): string {
    let address = '';

    if (this.lisansKisiKurum.mahalle) {
      address += this.lisansKisiKurum.mahalle + ' ';
    }

    if (this.lisansKisiKurum.street) {
      address += this.lisansKisiKurum.street + ' ';
    }

    if (this.lisansKisiKurum.no) {
      address += 'No: ' + this.lisansKisiKurum.no + ' ';
    }

    if (this.lisansKisiKurum.binaad) {
      address += this.lisansKisiKurum.binaad + ' ';
    }

    if (this.lisansKisiKurum.daire) {
      address += 'Daire: ' + this.lisansKisiKurum.daire + ' ';
    }

    if (this.lisansKisiKurum.kat) {
      address += 'Kat: ' + this.lisansKisiKurum.kat;
    }

    return address.trim();
  }

  altKullaniciSil(index: number) {
    this.altKullanicilar.splice(index, 1);
  }

  // Yeni alt kullanıcı ekleme
  yeniAltKullaniciEkle() {
    // Eğer zaten ekleme modundaysa çık
    if (this.yeniKullaniciEklemeModunda) {
      return;
    }

    // Yeni kullanıcı formunu temizle ve ekleme modunu aç
    this.yeniKullanici = {tc_no: '', eicra_eposta: '', selected: true};
    this.yeniKullaniciEklemeModunda = true;
  }

  async bitisTarihleriniGuncelle() {
    // Her alt kullanıcı için ayrı istek at
    for (const kullanici of this.mevcutAltKullanicilar) {
      // Alt kullanıcının TC kimlik numarası
      const tc_no = kullanici.tc_no || kullanici.SozlesmeMakSayisi;

      if (tc_no) {
        try {
          // Sadece TCKN ile POST isteği at
          const response = await this.$http.post(
              this.$store.state.icwApiUrl + "user-eicrapro-check-license",
              {tckn: tc_no}
          );

          // Gelen cevabı ilgili kullanıcıya yaz
          if (response.data && response.data.data) {
            this.$set(kullanici, 'BitisTarihi', response.data.data.BitisTarihi || "");
          }
        } catch (e) {
          console.error("Bitiş tarihi alınamadı:", e);
        }
      }
    }
  }

  // Yeni kullanıcıyı kaydet
  kaydetYeniKullanici() {
    // Validasyon
    if (!this.yeniKullanici.tc_no || !this.yeniKullanici.eicra_eposta) {
      alert("TC Kimlik No ve E-posta adresi zorunludur!");
      return;
    }

    const tcValidationResult = this.tcKuralKontrol(this.yeniKullanici.tc_no);
    if (tcValidationResult !== true) {
      alert(tcValidationResult);
      return;
    }

    // E-posta formatı kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.yeniKullanici.eicra_eposta)) {
      alert("Geçerli bir e-posta adresi giriniz!");
      return;
    }

    // Alt kullanıcılar listesine ekle
    this.altKullanicilar.push({
      tc_no: this.yeniKullanici.tc_no,
      eicra_eposta: this.yeniKullanici.eicra_eposta, // sadece eicra_eposta
      Rumuz: this.yeniKullanici.Rumuz,
      selected: this.yeniKullanici.selected,
      bitis_tarihi: ""
    });

    // Ekleme modunu kapat ve formu temizle
    this.yeniKullaniciEklemeModunda = false;
    this.yeniKullanici = {tc_no: '', eicra_eposta: '', Rumuz: '', selected: true};
  }

  // Yeni kullanıcı eklemeyi iptal et
  iptalEtYeniKullanici() {
    this.yeniKullaniciEklemeModunda = false;
    this.yeniKullanici = {tc_no: '', eicra_eposta: '', Rumuz: '', selected: true};
  }

  // TC ile kullanıcı arama (yeni kullanıcı formu için)
  async tcIleKullaniciAra(tcNo: string) {
    if (!this.tcGecerliMi(tcNo)) {
      alert("Geçerli bir TC Kimlik No giriniz!");
      return;
    }

    try {
      let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiTc/" + tcNo);

      if (response.data && response.data.length > 0) {
        const kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
        if (kullanici.kisi) {
          // TC'ye göre bulunan kullanıcının e-mail bilgisini otomatik doldur
          this.yeniKullanici.eicra_eposta = kullanici.kisi.Eposta;
          alert("Kullanıcı bulundu! E-mail adresi otomatik olarak dolduruldu.");
        }
      } else {
        alert("Bu TC kimlik numarası ile kayıtlı kullanıcı bulunamadı. Yeni kullanıcı olarak ekleyebilirsiniz.");
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu.");
    }
  }

  // Email ile kullanıcı arama (yeni kullanıcı formu için)
  async emailIleKullaniciAra(email: string) {
    if (!this.emailGecerliMi(email)) {
      alert("Geçerli bir e-posta adresi giriniz!");
      return;
    }

    try {
      let response = await this.$http.get(this.$store.state.panelApiUrl + "getLisansKisiEmail/" + email);

      if (response.data && response.data.length > 0) {
        const kullanici = Array.isArray(response.data) ? response.data[0] : response.data;
        if (kullanici.kisi) {
          // Email'e göre bulunan kullanıcının TC bilgisini otomatik doldur
          this.yeniKullanici.tc_no = kullanici.kisi.TcNo;
          alert("Kullanıcı bulundu! TC kimlik numarası otomatik olarak dolduruldu.");
        }
      } else {
        alert("Bu e-mail adresi ile kayıtlı kullanıcı bulunamadı. Yeni kullanıcı olarak ekleyebilirsiniz.");
      }
    } catch (e) {
      console.error(e);
      alert("Arama sırasında bir hata oluştu.");
    }
  }

  // Alt kullanıcı düzenleme
  duzenleAltKullanici(kullanici: any, index: number) {
    // Düzenleme dialog'u
    alert("Düzenleme özelliği yakında eklenecek.");
  }

  // Seçilen kullanıcı sayısını hesapla
  get secilenKullaniciSayisi() {
    let sayac = 0;

    // Ana kullanıcı seçildi mi?
    if (this.anaKullanici && this.anaKullanici.selected) {
      sayac++;
    }

    // Mevcut alt kullanıcılar
    sayac += this.mevcutAltKullanicilar.filter(k => k.selected).length;

    // Manuel eklenen alt kullanıcılar
    sayac += this.altKullanicilar.filter(k => k.selected).length;

    // Yeni ekleme modundaki kullanıcı (eğer seçiliyse)
    if (this.yeniKullaniciEklemeModunda && this.yeniKullanici.selected) {
      sayac++;
    }

    return sayac;
  }

  // Kullanıcı tipini belirle
  getKullaniciTipiByTcNo(tcNo: string) {
    // Ana kullanıcı mı?
    if (this.anaKullanici && this.anaKullanici.tc_no === tcNo) {
      return 'ana';
    }

    // Mevcut alt kullanıcı mı?
    const mevcutAlt = this.mevcutAltKullanicilar.find(k => k.tc_no === tcNo);
    if (mevcutAlt) {
      return 'mevcut_alt';
    }

    // Manuel eklenen alt kullanıcı mı?
    const manuelAlt = this.altKullanicilar.find(k => k.tc_no === tcNo);
    if (manuelAlt) {
      return 'yeni_alt';
    }

    return 'bilinmiyor';
  }

  // Kullanıcı tipi rengini getir
  getKullaniciTipRenk(item: any) {
    const tip = item.kullanici_tipi || this.getKullaniciTipiByTcNo(item.tc_no);
    switch (tip) {
      case 'ana':
        return 'primary'; // Vuetify primary rengi
      case 'mevcut_alt':
        return 'warning'; // Vuetify warning rengi
      case 'yeni_alt':
        return 'orange'; // Vuetify orange rengi
      default:
        return 'grey';
    }
  }

  // Kullanıcı tipi yazı rengini getir
  getKullaniciTipYaziRenk(item: any) {
    return 'white';
  }

  // Kullanıcı tipi iconunu getir
  getKullaniciTipIcon(item: any) {
    const tip = item.kullanici_tipi || this.getKullaniciTipiByTcNo(item.tc_no);
    switch (tip) {
      case 'ana':
        return 'mdi-account-star';
      case 'mevcut_alt':
        return 'mdi-account';
      case 'yeni_alt':
        return 'mdi-account-plus';
      default:
        return 'mdi-account-question';
    }
  }

  // Kullanıcı tipi adını getir
  getKullaniciTipAd(item: any) {
    const tip = item.kullanici_tipi || this.getKullaniciTipiByTcNo(item.tc_no);
    switch (tip) {
      case 'ana':
        return 'Ana Kullanıcı';
      case 'mevcut_alt':
        return 'Alt Kullanıcı';
      case 'yeni_alt':
        return 'Yeni Alt Kullanıcı';
      default:
        return 'Bilinmiyor';
    }
  }

  // Kullanıcı tipi kısa adını getir (kompakt görünüm için)
  getKullaniciTipKisaAd(item: any) {
    const tip = item.kullanici_tipi || this.getKullaniciTipiByTcNo(item.tc_no);
    switch (tip) {
      case 'ana':
        return 'Ana';
      case 'mevcut_alt':
        return 'Alt';
      case 'yeni_alt':
        return 'Yeni';
      default:
        return '?';
    }
  }

  // Sepet öğesi update success metodları
  onUpdateBasketRumuzSuccess(success: boolean) {
    if (success) {
      console.log("Sepet rumuz güncellendi");
    }
  }

  onUpdateBasketTcNoSuccess(success: boolean) {
    if (success) {
      console.log("Sepet TC Kimlik No güncellendi");
    }
  }

  onUpdateBasketEpostaSuccess(success: boolean) {
    if (success) {
      console.log("Sepet e-posta güncellendi");
    }
  }

  // Satır rengi belirleme
  getSatirRengi(item: any) {
    if (!item.tc_no && !item.eicra_eposta) {
      return ''; // Normal ürünler için renk yok
    }

    const tip = item.kullanici_tipi || this.getKullaniciTipiByTcNo(item.tc_no);
    switch (tip) {
      case 'ana':
        return 'ana-kullanici-satir';
      case 'mevcut_alt':
        return 'alt-kullanici-satir';
      case 'yeni_alt':
        return 'yeni-alt-kullanici-satir';
      default:
        return '';
    }
  }

  onUpdateAltKullaniciRumuzSuccess(success: boolean) {
    if (success) {
      this.$toast && this.$toast.success('Rumuz başarıyla güncellendi!');
    }
  }

  // Alt kullanıcı e-posta kaydetme fonksiyonu
  async kaydetAltKullaniciEposta(kullanici: any) {
    if (!kullanici.email || !this.emailGecerliMi(kullanici.email)) {
      alert('Geçerli bir e-posta adresi giriniz!');
      return;
    }

    try {
      // E-posta adresini güncelle
      kullanici.eicra_eposta = kullanici.email;

      // Başarı mesajı
      this.$toast && this.$toast.success('E-posta adresi güncellendi!');
    } catch (error) {
      console.error('E-posta güncellenirken hata:', error);
      this.$toast && this.$toast.error('E-posta güncellenirken hata oluştu!');
    }
  }

  onUpdateAnaKullaniciRumuzSuccess(success: boolean) {
    if (success) {
      this.$toast && this.$toast.success('Rumuz başarıyla güncellendi!');
    }
  }

  // TC kimlik numarası input handler
  tcInputHandler(value: string) {
    if (value) {
      this.lisansKisiKurum.TcNo = value.replace(/[^0-9]/g, '');
    }
  }

  // Yeni müşteri oluşturma fonksiyonu
  yeniMusteriOlustur() {
    this.yeniMusteri = true;
    this.musteri = true;
    this.resetForm();
    this.lisansKisiKurum.tur = false; // Varsayılan olarak bireysel

    // Yeni müşteri için kullanıcı verilerini temizle
    this.anaKullanici = null;
    this.altKullanicilar = [];
    this.mevcutAltKullanicilar = [];
    this.urunler = [];

    // E-icraPro kullanıcı seçimi alanını sıfırla
    this.isEicraPro = false;
    this.yeniKullaniciEklemeModunda = false;
  }

  get tarihler() {
    return {
      eicraproBitisTarihi: this.tarihler.eicrapro.eicraproBitisTarihi || null,
      icraproWebBitisTarihi: this.tarihler.icrapro.icraproWebBitisTarihi || null
    };
  }

}
